import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { TicketSaleFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<TicketSaleFormType>();
  const [otherCost = 0, discount = 0, flightSales = []] = useWatch({
    name: ['otherCost', 'discount', 'flightSales'],
    control,
  });

  const data = React.useMemo(() => {
    const subtotal = flightSales.reduce((prev, fs) => {
      const subtotalAirlines =
        fs.flightSaleGuests.length *
        fs.flightSaleAirlines.reduce((prev, fsa) => prev + (fsa.price || 0), 0);

      const subtotalAddOns = fs.flightSaleAddOns.reduce(
        (prev, fsao) => prev + (fsao.price || 0),
        0,
      );

      return prev + subtotalAirlines + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost: otherCost || 0,
      discount: discount || 0,
      total,
    };
  }, [discount, flightSales, otherCost, setValue]);

  return data;
}
